import { EditIcon, Group, InfiniteTable } from '@/components/_common';
import { CheckOutlined } from '@ant-design/icons';
import { useDisclosure, useWindowSize } from '@/hooks';
import { Button, Divider, Modal, ModalProps, Space } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useState } from 'react';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import StatusWorkOrderModal from '../StatusWorkOrderModal';
import { GPStatus } from '@/core/domain/visual-management/status/status.types';
import { useGPStatusList } from '@/core/domain/visual-management/status/status.hooks';
import WorkOrderStatusTag from '@/components/_common/WorkOrderStatusTag';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

export interface Props extends Omit<ModalProps, 'onCancel'> {
  onCallback: (statusId: string) => void;
  onCancel: () => void;
}

export default function StatusWorkOrderSelectModal({
  onCallback,
  onCancel,
  ...props
}: Props) {
  const { isMobile } = useWindowSize();
  const hasCreateStatusPermission = hasPermissions([
    Authorities.YARDMANAGEMENT_FOLLOWUP_CREATE_STATUS,
  ]);

  const { data, isFetching } = useGPStatusList(props.open);

  const [modalOpened, modalActions] = useDisclosure();
  const [statusSelected, setTagSelected] = useState<GPStatus>();

  async function handleCallback(statusId: string) {
    await onCallback(statusId);

    onCancel();
  }

  const columns: ColumnsType<GPStatus> = [
    {
      dataIndex: 'name',
      title: 'Descrição',
      render: (_, record) => (
        <WorkOrderStatusTag color={record.color} label={record.name} />
      ),
    },
    {
      dataIndex: 'actions',
      fixed: 'right',
      align: 'right',
      render: (_, row) => (
        <Space direction="horizontal" size="middle" style={{ display: 'flex' }}>
          <EditIcon
            size={24}
            iconProps={{
              onClick: () => {
                setTagSelected(row);
                modalActions.open();
              },
            }}
          />

          <Divider type="vertical" />

          <Button
            type="primary"
            onClick={() => handleCallback(row.id)}
            icon={<CheckOutlined />}
          />
        </Space>
      ),
      width: '20%',
    },
  ];
  return (
    <>
      <Modal
        {...props}
        title="Seleção de status para o complemento"
        footer={[]}
        onCancel={onCancel}
      >
        {props.confirmLoading && (
          <ModalLoadingOverlay
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              backdropFilter: 'blur(2px)',
            }}
            messages={['Incluindo Etiqueta...']}
          />
        )}

        <Group
          position="between"
          align="center"
          gap={24}
          style={{ flexDirection: isMobile ? 'column' : undefined }}
        >
          <Button
            type="primary"
            size="large"
            block
            disabled={!hasCreateStatusPermission}
            onClick={modalActions.open}
            style={{ marginBottom: 24 }}
          >
            Criar Status
          </Button>
        </Group>

        <InfiniteTable<GPStatus>
          columns={columns}
          dataSource={data}
          loading={isFetching}
          rowKey={(row) => row.id}
        />
      </Modal>

      <StatusWorkOrderModal
        statusSelected={statusSelected}
        open={modalOpened}
        onCancel={() => {
          setTagSelected(undefined);
          modalActions.close();
        }}
      />
    </>
  );
}
